// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__1wX2a","logoWrapper":"Logo_logoWrapper__35yAf"};